import { render, staticRenderFns } from "./ResourceMetaDataPage.html?vue&type=template&id=42ce60a9&external"
import script from "./ResourceMetaDataPage.js?vue&type=script&lang=js&external"
export * from "./ResourceMetaDataPage.js?vue&type=script&lang=js&external"
import style0 from "./ResourceMetaDataPage.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports